import { Draggable, type DraggableChildrenFn } from '@hello-pangea/dnd';
import type { ReactNode } from 'react';

interface OptionalDroppableProps {
  /** Chooses between the draggable children and the non-draggable fallback */
  draggable: boolean | undefined;
  /** Passed though to Draggable */
  draggableId: string;
  /** Passed through to Draggable */
  index: number;
  /** children you would pass to <Draggable> */
  children: DraggableChildrenFn;
  /** Component to render if not draggable */
  fallback: ReactNode;
}
/** Wraps the children in a draggable, if draggable = true, else just the children  */
export const OptionalDraggable = ({
  draggable,
  draggableId,
  index,
  children,
  fallback,
}: OptionalDroppableProps) => {
  if (draggable) {
    return (
      <>
        <Draggable draggableId={draggableId} index={index}>
          {children}
        </Draggable>
      </>
    );
  } else return <>{fallback}</>;
};
